import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ListSortableFormModule } from '../list-sortable-form/list-sortable-form.module';
import { ListSortableItemComponent } from './list-sortable-item.component';

@NgModule({
  exports: [ListSortableItemComponent],
  imports: [CommonModule, ListSortableFormModule, ListSortableItemComponent],
})
export class ListSortableItemModule {}
export { ListSortableItemComponent } from './list-sortable-item.component';
